<template>
  <validation-provider
    :disabled="!validatable"
    :name="fieldName || label"
    :rules="validatable ? rules : ''"
    :vid="vid"
    v-slot="validationContext"
    slim
  >
    <b-form-group
      v-bind="$attrs"
      :label="fieldLabel"
      :state="getValidationState(validatable, validationContext)"
      :label-cols-sm="labelColsSm"
      :class="controlClass"
      :label-class="labelClass"
    >
      <slot v-bind:state="getValidationState(validatable, validationContext)">
        <b-form-file
          :value="value"
          :state="getValidationState(validatable, validationContext)"
          @input="emitValue"
          :placeholder="placeholder"
          :multiple="multiple"
          :accept="accept"
        />
      </slot>
      <b-form-invalid-feedback
        v-if="validatable"
        :state="getValidationState(validatable, validationContext)"
      >
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { baseValidatableMixin } from "@foys-tech/foys-utils";

export default {
  mixins: [baseValidatableMixin],
  props: {
    /**
     * Multiple files can be selected
     */
    multiple: {
      type: Boolean,
      default: false,
    },
    /**
     * File types that can be selected
     */
    accept: {
      type: String,
      default: "",
    },
  },
};
</script>
